import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getSchools, getClasses, signup } from '../../redux';
import MenuItem from 'material-ui/MenuItem';
import StudentSignupForm from './StudentSignupForm';
import "./index.css";

function StudentSignupFormContainer (props) {
    const {
        authErrCode,
        classes,
        schools,
        // actions
        signup,
        getClasses,
        getSchools
    } = props;

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [school, setSchool] = useState("");
    const [password, setPassword] = useState("");
    const [errMsg, setErrMsg] = useState("");
    const [currentClass, setCurrentClass] = useState("");
    const [studentId, setStudentId] = useState("");

    useEffect(() => {
        getSchools();
        getClasses();
    }, []);

    useEffect(() => {
        let authErrCodeStatus = authErrCode && authErrCode.signup && authErrCode.signup.status;

        if (authErrCodeStatus < 500 && authErrCodeStatus > 399) {
            setErrMsg("An account with that email has already been created.");
        } else if (authErrCodeStatus > 499) {
            setErrMsg("Server error!");
        }
    }, [authErrCode]);

    const getMappedSchoolOptions = () => {
        return schools !== undefined ? schools.filter(s => s.status === "Active").map((school, index) => {
            return (<MenuItem
                        key={index + school}
                        value={school.name}
                        primaryText={school.name}
                        id="school"
                    />)
        }) : null;
    }

    const getMappedClassOptions = (inputSchool) => {
        // value is the class _id (not the name): two classes can share a name,
        // and a name-based lookup would enroll the student in the wrong one.
        return classes !== undefined ? classes
                .filter(classObject => classObject.schoolName === inputSchool && classObject.status === "Active")
                .map((classObject) => {
                    return (<MenuItem
                                key={classObject._id}
                                value={classObject._id}
                                primaryText={classObject.name}
                                id="class"
                            />);
                })
                : null;
    }

    const handleChange = (e) => {
        const name = e.target.name;
        const handle = 
        name === "firstName" ? setFirstName :
        name === "lastName" ? setLastName :
        name === "email" ? setEmail :
        name === "studentId" ? setStudentId :
        name === "password" ? setPassword :
        name === "school" ? setSchool :
        name === "class" ? setCurrentClass : null;

        handle(e.target.value);
    }

    const handleDropdownChangeSchool = (e) => {
        setSchool(e.target.innerText.trim());
        setCurrentClass("");
    }

    // material-ui SelectField onChange is (event, index, value); value is the class _id
    const handleDropdownChangeClass = (e, index, value) => {
        setCurrentClass(value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (currentClass === "" ||
            firstName === "" ||
            lastName === "" ||
            email === "" ||
            studentId === "" ||
            password === "" ||
            school === "") {
            setErrMsg("Please fill out all the fields.");
        } else {
            const thisSchool = schools.find(s => s.name === school)
            const classObject = classes.find(c => c._id === currentClass && c.school === thisSchool._id)
            if (!classObject) {
                setErrMsg("Please select a class.");
                return;
            }
            signup({
                firstName: firstName.trim(),
                lastName: lastName.trim(),
                school: thisSchool._id,
                classes: [classObject._id],
                email: email.trim(),
                studentId: studentId.trim(),
                password: password,
                type: "student"
            });
        }

    }

    return (
        <StudentSignupForm
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            handleDropdownChangeSchool={handleDropdownChangeSchool}
            handleDropdownChangeClass={handleDropdownChangeClass}
            school={school}
            schoolOptions={getMappedSchoolOptions()}
            class={currentClass}
            classOptions={getMappedClassOptions(school)}
            firstName={firstName}
            lastName={lastName}
            email={email}
            password={password}
            studentId={studentId}
            errMsg={errMsg}/>
    );
}

export default connect(state => state.root, { getSchools, getClasses, signup })(StudentSignupFormContainer);
